import React, { Component } from 'react'
//Components
import SideBar from "../../components/Sidebar/Sidebar";
import MobileSubHeader from "../../components/PageHeader/MobileSubHeader";
//Miscellaneous
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import { isDesktop } from "react-device-detect";
import { withNamespaces } from "react-i18next";

export class Contact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      skypeLink: "live:.cid.20c93fecea…",
    };
  }

  copyToClipboardHandler = event => {
    this.linkRef.current.select();
    document.execCommand("copy");
  }

  imageImport = (r) => {
    let images = {};
    r.keys().map((item) => {
      return (images[item.replace("./", "")] = r(item)["default"]);
    });
    return images;
  };

  render() {
    const { t } = this.props;
    const image = this.imageImport(require.context("../../assets/images/contactus/", false, /\.(png|jpe?g|svg|webp)$/));

    return (
      <Auxiliary>
        {isDesktop ? (
          <section className="pf-dashboard contact-us">
            <div className="x-container">
              <SideBar />
              <div className="row">
                <div className="db-col col-12">
                  <div className="pd-card-col">
                    <h4>{t('contact-us.contact-us')}</h4>
                    <div className="pd-content">
                      <div className='row justify-content-center'>
                        <div className='col-4'>
                          <span className="card-shadow">
                            <img src={image["contact-bg.png"]} alt="contact background" />
                            <div className='contact-wrap'>
                              <img src={image["contact.png"]} alt="bg" />
                              <div>
                                <p className='fw-bold'>{t('contact-us.joint-venture')}</p>
                                <p>{t('contact-us.click-consult')}</p>
                              </div>
                              <button className='btn-gradient-blue w-100'>{t('contact-us.consult')}</button>
                            </div>
                          </span>
                        </div>
                        <div className='col-4'>
                          <span className="card-shadow">
                            <img src={image["contact-bg.png"]} alt="contact background" />
                            <div className='contact-wrap'>
                              <img src={image["skype.png"]} alt="bg" />
                              <div>
                                <p className='fw-bold'>{t('contact-us.joint-skype')}</p>
                                <input
                                  ref={this.linkRef}
                                  type="text"
                                  className="form-control"
                                  name="skypeLink"
                                  defaultValue={this.state.skypeLink}
                                  readOnly
                                />
                              </div>
                              <div className='d-flex gap-1'>
                                <button type="button" className="btn btn-gradient-blue" onClick={(event) => this.copyToClipboardHandler(event)}>
                                {t("promote-link.copy")}
                                </button>
                                <button className='btn btn-white'>{t("download-app.download")}</button>
                              </div>
                            </div>
                          </span>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        ) :
          <section className="pf-m-dashboard contact-us">
            <MobileSubHeader
              className="bg-white"
              returnPage="/"
              header="Contact Us"
              modalHeader={true}
              modalHandler={this.toggleModal}
            />

            <div className='row gap-3 p-3'>
              <div>
                <span className="card-shadow">
                  <img src={image["contact-bg-m.png"]} alt="contact background" />
                  <div className='contact-wrap'>
                    <img src={image["contact.png"]} alt="bg" />
                    <div>
                      <p className='fw-bold'>{t('contact-us.joint-venture')}</p>
                      <p>{t('contact-us.click-consult')}</p>
                    </div>
                    <button className='btn-gradient-blue w-100'>{t('contact-us.consult')}</button>
                  </div>
                </span>
              </div>

              <div>
                <span className="card-shadow">
                  <img src={image["contact-bg-m.png"]} alt="contact background" />
                  <div className='contact-wrap'>
                    <img src={image["skype.png"]} alt="bg" />
                    <div>
                      <p className='fw-bold'>{t('contact-us.joint-skype')}</p>
                      <input
                        ref={this.linkRef}
                        type="text"
                        className="form-control"
                        name="skypeLink"
                        defaultValue={this.state.skypeLink}
                        readOnly
                      />
                    </div>
                    <div className='d-flex gap-3 w-100'>
                      <button className='btn-gradient-blue w-50'>{t("promote-link.copy")}</button>
                      <button className='btn-white w-50'>{t("download-app.download")}
                      </button>
                    </div>
                  </div>
                </span>
              </div>
            </div>
          </section>
        }
      </Auxiliary>
    )
  }
}

export default (withNamespaces('translation')(Contact));